<template>
    <div id="aplicpage">
        <div id="toolH">
            <div  class="head flex_b">
                <h4>{{$t('purchaseOrder_warehousing_application')}}</h4>
                <i class="el-icon-close" @click="closecontent"></i>
            </div>
            <div class="flex_b abtn">
                <el-button class="marbtn btn"  type="primary" @click="addapic('add')" size="mini">{{$t('button_newly_added')}}</el-button>
            </div>
        </div>
        <div class="scrollview" v-loading="loading" v-if="tableHeight!=0"  :style="'height: '+tableHeight+'px'">
            <div class="borderadis"  v-for="(item,index) in tableData" :key="index" @click="addapic('edit',item)">
                <div class="flex_b pad4">
                    <div class="flex alc">
<!--                        <div :class="[baseerp+'color','marr5']">入库申请</div>-->
                        <div class="color marr5">{{'NO.'+item.i_id}}</div>
                        <div class="color">{{item.c_typeTxt}}</div>
                    </div>
                    <div class="flex">
                        <div class="wid60 marr5">{{$t('purchaseOrder_review_status')}}</div>
                        <div :class="item.i_state==0?'shenpi':(item.i_state==1?'complete':'red')">{{item.stateTxt}}</div>
                    </div>
                </div>
                <div class="flex alc pad4">
                    <div class="wid60 marr5">{{$t('form_warehouse')}}</div>
                    <div>{{item.vc_inckname}}</div>
                </div>
                <div class="flex alc pad4">
                    <div class="wid60 marr5">{{$t('purchaseOrder_expiration_time')}}</div>
                    <div>{{item.dt_expiretime}}</div>
                </div>
                <div class="sub" v-for="(subitem,subindex) in item.sub" :key="'sub'+subindex">
                    <div class="flex marb3">
                        <div class="wid60 marr5">{{$t('form_product_name')}}</div>
<!--                        <div>{{subitem.vc_pzname}}</div>-->
                        <div>{{subitem.pm}}</div>
                    </div>
                    <div class="flex marb3">
                        <div class="wid60 marr5">{{$t('form_batch_number')}}</div>
                        <div>{{subitem.vc_no}}</div>
                    </div>
                    <div class="flex marb3">
                        <div class="flex wid50">
                            <div class="wid60 marr5">{{$t('form_quantity')}}</div>
                            <div>{{subitem.f_num+' '+subitem.vc_unit}}</div>
                        </div>
                        <div class="flex wid50" v-if="item.c_type!=41">
                            <div class=" marr5">{{$t('purchaseOrder_quantity_in_stock')}}</div>
                            <div>{{subitem.f_innum+' '+subitem.vc_unit}}</div>
                        </div>
                    </div>
                    <div class="flex marb3">
                        <div class="flex wid50">
                            <div class="wid60 marr5">{{$t('purchaseOrder_order_quantity')}}</div>
                            <div>{{subitem.f_ldnum+' '+subitem.vc_unit}}</div>
                        </div>
                        <div class="flex wid50" v-if="item.c_type!=41">
                            <div class=" marr5">{{$t('purchaseOrder_order_tsnum')}}</div>
                            <div>{{subitem.f_tsnum+' '+subitem.vc_unit}}</div>
                        </div>
                    </div>
                    <div class="flex marb3">
                        <div class="flex wid50">
                            <div class="wid60 marr5">{{$t('purchaseOrder_order_dsnum')}}</div>
                            <div>{{subitem.f_dsnum+' '+subitem.vc_unit}}</div>
                        </div>
                        <div class="flex wid50">
                            <div class=" marr5">{{$t('purchaseOrder_order_jsnum')}}</div>
                            <div>{{subitem.f_rejnum+' '+subitem.vc_unit}}</div>
                        </div>
                    </div>
                    <div class="flex">
                        <!--<div class="flex wid50">
                            <div class="wid60 marr5">{{$t('purchaseOrder_application_type')}}</div>
                            <div>{{item.c_typeTxt}}</div>
                        </div>-->
                        <div class="flex wid50">
                            <div class="wid60 marr5">{{$t('purchaseOrder_is_it_finished')}}</div>
                            <div>{{subitem.i_over==0?$t('form_deny'):$t('form_correct')}}</div>
                        </div>
                    </div>
                </div>
                <div class="flex pad4">
                    <div class="flex wid50">
                        <div class="wid60 marr5">{{$t('form_input_person')}}</div>
                        <div>{{item.vc_lruname}}</div>
                    </div>
                    <div class="flex wid50">
                        <div class="wid60 marr5">{{$t('form_enter_time')}}</div>
                        <div>{{item.dt_createtime}}</div>
                    </div>
                </div>
            </div>
            <!--<div class="txtc" slot="empty">
                <h4>{{dataText}}</h4>
            </div>-->
        </div>
        <el-pagination
                class="fr mrr9"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-sizes="[10, 15, 30]"
                :page-size="pageSize"
                layout="sizes, prev, pager, next"
                :total="tableTotal">
        </el-pagination>
        <!--申请dialog-->
        <!--<div :class="baseerp+'div'">
            <el-dialog
                    width="1000px"
                    :title="title+'-入库申请'"
                    :visible.sync="dialogVisible"
                    :close-on-click-modal="false"
                    @close="cancelDialog"
                    v-if="dialogVisible">
                <add-appic :application="application" @close="cancelDialog"></add-appic>
            </el-dialog>
        </div>-->
    </div>
</template>


<script>
    import { Loading} from 'element-ui';
    import * as API from "./api";
    import {baseerp} from "@/utils/baseUrl";
    //import addAppic from "./addAppic";
    export default {
        name: "warehouseApplic",
        components: {
            //addAppic,
        },
        props:{
            appdata:{
                type:Object,
                required:true,
            }
        },
        data() {
            return {
                loading:true,
                row:{},
                //title:"",
                //dialogVisible:false,
                application:{},
                dataText:this.$t('tips_data_loading_in_progress'),
                vc_orderno:"",
                tableData:[],
                pageSize:15,
                currentPage:1,
                tableTotal:0,
                highlightCurrentRow:false,
                tableHeight:0,
                baseerp:"",
            }
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    // console.log(n,12312312)
                    this.onResize(n);
                },
                deep:true,
            },
            appdata: {
                 handler() {
                     if (this.appdata) {
                         //console.log("vc_orderno变了",this.appdata.vc_orderno);
                         this.vc_orderno=this.appdata.vc_orderno;
                         this.row=this.appdata.row;
                         this.sqlist();
                     }
                 },
                 immediate: true,
                 deep: true
             }
        },
        activated(){
            this.onResize();
        },
        mounted() {
            this.baseerp=baseerp;
            this.$nextTick(function () {
                this.onResize();
                //window.addEventListener('resize',this.heightAuto);

            });


        },
        methods:{
            //关闭dialog
            cancelDialog(){
                //console.log("guanleeeeeeeeeeeeeeeeeeeee")
                this.application={};
                this.dialogVisible=false;
            },
            addapic(type,data){
                if(type=="edit"){
                    this.$emit("opensq",data,"edit");
                }else if(type=="add"){
                    this.$emit("opensq",this.row,"add");
                }

                //this.title="新增";
                //this.dialogVisible=true;
            },
            closecontent(){
                this.$emit('closetent','applic')
            },

            handleSizeChange(val){
                //console.log(val,"page_count");
                this.pageSize=val;
                ///调用列表接口
                this.sqlist();
            },
            handleCurrentChange(val){
                //console.log(val,"page_size");
                this.currentPage=val;
                ///调用列表接口
                this.sqlist();
            },
            onResize (n){
                //this.tableHeight = $(".aplicpage").height()*1-  28 - 36 - $(".abtn").height()*1;
                //console.log(" $(\".aplicpage\").height()*1", $(".aplicpage").height()*1);
                //console.log("this.tableHeight-----------------------",this.tableHeight)

                if (n==undefined) n=this.$root.workSize;
                //console.log("n",n)
                //$("#htpage").height(n.h);
                //$("#htpage").width(n.w);
                //this.tableHeight= n.h-80;
                this.tableHeight = $("#aplicpage").height()*1 -  30 - 70;
                //console.log($("#aplicpage").height()*1,"------------22")
                //console.log($("#toolH").height()*1,"=================22")
                //console.log(this.tableHeight,"????????????????22")
                //$(".sp_content").height($(".sphome").height()*1 -  $("#toolbar").height()*1);
                //console.log("sp_content-height",$(".sp_content").height)
                //this.tableHeight = $(".sp_content").height
            },

            //入库申请列表
            async sqlist(vc_no){
                this.loading=true;
                /*if(pageSize!=undefined) {
                    //console.log(pageSize,"addddd")
                    this.currentPage=pageSize;
                }*/
                let param = {
                    //vc_orderno:this.vc_orderno,
                    dt_startime: "",
                    dt_endtime: "",
                    vc_search:"",
                    vc_no:vc_no?vc_no:this.vc_orderno,
                    pageSize: this.pageSize,
                    currentPage: this.currentPage,
                    c_type: 4,
                };
                //console.log("sqparam",param);
                let res = await API.sqlist(param);
                if (res.code == 1) {
                    this.loading=false;
                    if (res.data.list.length==0){
                        this.dataText=this.$t('tips_no_data_available_at_the_moment')
                    }
                    this.tableData=res.data.list;
                    this.tableTotal=res.data.total;
                    //console.log("this.tableData",this.tableData,this.tableTotal)
                } else if (res.code == -2) {
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.loading=false;
                    this.$message.error(res.message);
                }
            },

        },
    }
</script>

<style  lang="scss" scoped>
    .scrollview{
        overflow: auto;
    }
    .el-dialog__headerbtn .el-dialog__close{
        color: white;
    }
    .el-dialog__title{
        color: white;
    }
    .el-dialog__body{
        padding: 10px 20px;
    }
    .marbtn{
        margin: 3px 0 0 9px;
    }
    .txtc{
        text-align: center;
    }
    .shenpi{
        color:#f08c00;
        font-size: 14px;
        font-weight: 700;
    }
    .red{
        color:#fa5050;
        font-size: 14px;
        font-weight: 700;
    }
    .complete{
        color:#3cb44b;
        font-size: 14px;
        font-weight: 700;
    }
    .flex_b{
        display: flex;
        justify-content: space-between;
    }
    .alc{
        align-items: center;
    }
    .sub{
        background-color: #efefef;
        padding: 4px;
    }
    .pad4{
        padding: 0px 4px;
    }
    .borderadis{
        border: 3px solid #efefef;
        border-radius: 8px;
        margin: 3px 9px 0px 9px;
        padding: 14px;
    }
    .marb3{
        margin-bottom: 3px;
    }
    .border{
        border-bottom: 1px  solid #efefef;
    }
    .marr5{
        margin-right: 5px;
    }
    .disB{
        display: block;
    }
    .wid30{
        width: 30%;
    }
    .wid50{
        width: 50%;
    }
    .wid100{
        width: 100%;
    }
    .text {
        font-size: 12px;
    }

    .item {
        padding: 9px 0;
        margin-right: 0px;
    }

    .box-card {
        //width: 480px;
        width: 100%;
        border-radius: 18px;
        margin-top: 10px;
    }
    .flex{
        display: flex;
    }
    .wid60{
        max-width: 60px;
        min-width: 60px;
    }
    .ghwcolor{
        color:var(--light);
        font-weight: 500;
        font-size: 16px;
    }
    .ghwcolor{
        color:#3e82e8;
        font-weight: 500;
        font-size: 16px;
    }
    .havaycolor{
        color: #e8c984;
        font-weight: 500;
        font-size: 16px;
    }
    .head{
        display: flex;
        align-items: center;
        padding: 0 20px;
        background: var(--light);
        justify-content: space-between;
        height: 30px;
        color: var(--whiteColor);
    }

</style>